/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DashboardSummary_accountSummary = {
    readonly name: string;
    readonly account: string;
    readonly availableBalance: number;
    readonly lastPaid: {
        readonly amount: number;
        readonly date: string;
    } | null;
    readonly " $refType": "DashboardSummary_accountSummary";
};
export type DashboardSummary_accountSummary$data = DashboardSummary_accountSummary;
export type DashboardSummary_accountSummary$key = {
    readonly " $data"?: DashboardSummary_accountSummary$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardSummary_accountSummary">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardSummary_accountSummary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "account",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availableBalance",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DashboardLastPaid",
      "kind": "LinkedField",
      "name": "lastPaid",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DashboardAccountSummary",
  "abstractKey": "__isDashboardAccountSummary"
};
(node as any).hash = 'c243fad8dfde4121f722198ce5c09863';
export default node;
